// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__22l5L","buttons":"SendReceipts_buttons__2BVHC","email":"SendReceipts_email__1t66e","bookApptTitle":"SendReceipts_bookApptTitle__3798e"};